import React from "react";
//Limitless imports
import { flagMessage, FORWARDED } from "../../../portal";
import { log as pilog } from "@limitless/common/utils";
import { useNotificationContext } from "@limitless/common/hooks/notification/NotificationContext";
import { useExpertMessageContext } from "../expert-message/ExpertMessageContext";
import { useExpertMessageResponseContext } from "../expert-message-response/ExpertMessageResponseContext";
import { useExpertTaskListContext } from "../expert-task-list/ExpertTaskListContext";
import { INITIAL_DROP_DOWN_FIELD, INITIAL_FIELD } from "../../utils/FieldValidators";
export const INITIAL_MESSAGE_FLAG_STATE = {
  report: {
    code: INITIAL_DROP_DOWN_FIELD,
    body: INITIAL_FIELD,
    noteKey: "reportNote",
    reasonKey: "reportReason",
    reasonDescKey: "reportReasonDesc",
    dialogueTitle: "Conversation has been reported",
    errorMessage: "Failed to Report task. Please try again."
  },
  escalation: {
    code: INITIAL_DROP_DOWN_FIELD,
    body: INITIAL_FIELD,
    noteKey: "escalateNote",
    reasonKey: "escalateReason",
    reasonDescKey: "escalateReasonDesc",
    dialogueTitle: "Conversation has been forwarded",
    errorMessage: "Failed to Forward task. Please try again."
  }
};
export const useMessageFlag = () => {
  const log = pilog.getLogger("useMessageFlag");
  const [messageFlag, setMessageFlag] = React.useState(INITIAL_MESSAGE_FLAG_STATE);
  const {
    addFailureNotification
  } = useNotificationContext();
  const messageContext = useExpertMessageContext();
  const {
    clearMessageResponse
  } = useExpertMessageResponseContext();
  const {
    removeTaskListRecordAndBlackList,
    addTaskListRecord
  } = useExpertTaskListContext();

  //if the messageId changes, reset the message flag context
  React.useEffect(() => {
    setMessageFlag(INITIAL_MESSAGE_FLAG_STATE);
  }, [messageContext.message.messageId]);
  log.debug(messageContext);
  const {
    message,
    messageResources,
    addTempDialogue,
    changeMessageState
  } = messageContext;
  const setMessageFlagDetails = (type, value) => {
    const newValue = {
      [type]: {
        ...messageFlag[type],
        ...value
      }
    };
    setMessageFlag({
      ...messageFlag,
      ...newValue
    });
  };
  const sendMessageFlag = type => {
    const flagData = messageFlag[type];
    const {
      body,
      dialogue,
      messageProps
    } = getFlagDialogue(flagData);
    //we add the temp dialogue, but we don't replace it with the API response as there isn't one :)
    //once flagged a message cannot be worked upon by an expert anymore
    removeTaskListRecordAndBlackList(message.messageId);
    log.debug("adding temp dialogue");
    addTempDialogue(body, null, dialogue, messageProps, true, FORWARDED);
    const payload = {
      type,
      description: flagData.code.label,
      reason: flagData.code.value,
      note: flagData.body.value
    };
    log.debug("flagging message");
    flagMessage(message, payload, response => {
      //don't need to do anything on success
      if (response.hasError) {
        //an error, uh oh, let's inform the user & add back to the inbox
        addTaskListRecord(message.inbox);
        addFailureNotification(flagData.errorMessage);
      }
      //if for any reason there was a partial response, clear it
      clearMessageResponse();
    });
  };
  const sendCustomerCompleteFlag = () => {
    const messageProps = {
      isLastCustomerDialogue: false,
      hasFlaggedConversationComplete: true,
      hasExpertTouched: true,
      addingDialogue: false
    };
    const payload = {
      type: "custConfirmation"
    };
    flagMessage(message, payload, response => {
      //don't need to do anything on success
      if (response.hasError) {
        //an error, uh oh, let's inform the user
        addFailureNotification("Failed to set Conversation Complete. Please try again.");
      } else {
        changeMessageState(message.conversationState.state, {
          ...message,
          ...messageProps
        });
      }
    });
  };
  const getFlagDialogue = flagData => {
    const messageProps = {
      [flagData.noteKey]: flagData.body.value,
      [flagData.reasonKey]: flagData.code.value,
      [flagData.reasonDescKey]: flagData.code.label,
      claimedBy: null
    };
    const dialogue = {
      type: "escalation"
    };
    return {
      messageProps,
      dialogue,
      body: flagData.body.value
    };
  };
  return {
    messageFlag,
    setMessageFlagDetails,
    sendMessageFlag,
    sendCustomerCompleteFlag,
    messageResources
  };
};